'use client'

import { Link } from '@/shared/navigation'
import type { ReactNode } from 'react'

type DelmanPageHeaderProps = {
  backHref: string
  backLabel?: string
  title: string
  subtitle?: string
  meta?: string
  badge?: ReactNode
}

export function DelmanPageHeader({
  backHref,
  backLabel = 'Kembali',
  title,
  subtitle,
  meta,
  badge,
}: DelmanPageHeaderProps) {
  return (
    <header className="space-y-2 border-b border-surface-variant pb-3">
      <Link
        href={backHref}
        className="inline-flex items-center gap-1 text-label-md text-primary min-h-[44px] -ml-1 px-1"
      >
        <span className="material-symbols-outlined text-lg">arrow_back</span>
        {backLabel}
      </Link>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          {meta && <p className="font-mono text-label-md text-on-surface-variant">{meta}</p>}
          <h1 className="text-headline-md text-primary mt-0.5">{title}</h1>
          {subtitle && <p className="text-body-sm text-on-surface-variant mt-1">{subtitle}</p>}
        </div>
        {badge}
      </div>
    </header>
  )
}
